<script>
  import { Link } from "svelte-routing";
  import { onMount } from "svelte";
  import { writable } from "svelte/store";
  import emailjs from "@emailjs/browser";

  // Contact form state
  let firstName = "";
  let lastName = "";
  let company = "";
  let email = "";
  let phone = "";
  let helpOption = "";
  let message = "";
  let submitting = false;
  let submitStatus = "";

  async function handleSubmit() {
    submitting = true;
    submitStatus = "";

    const payload = {
      title: "Free Consultation Request",
      to_email: "craft2code743@gmail.com",
      name: firstName + " " + lastName,
      from_name: firstName + " " + lastName,
      email: email,
      from_email: email,
      company: company,
      phone: phone,
      help_option: helpOption,
      message: message,
    };

    try {
      const response = await emailjs.send(
        "service_3137pxo",
        "template_kxc76ui",
        payload
      );
      console.log("✅ Email sent successfully!", response.status, response.text);
      submitStatus = "success";
      firstName = ""; lastName = ""; company = ""; email = "";
      phone = ""; helpOption = ""; message = "";
    } catch (err) {
      console.error("❌ EmailJS failed to send email.", err);
      submitStatus = "error";
    }
    submitting = false;
  }

  let testimonialIndex = 0;
  const testimonials = [
    {
      quote:
        "I've been consistently impressed with the quality of service provided by this company. Highly recommended! ER erg ersrt hhrs hqhet hqethethq hetnhqr eth nene neqt nqen etnhte qne netnq qnqet Highly recommended! ER erg ersrt hhrs hqhet hqethethq hetnhqr eth nene neqt nqen etnhte qne netnq qnqet Highly recommended! ER erg ersrt hhrs hqhet hqethethq hetnhqr eth nene neqt nqen etnhte qne netnq qnqet ",
      author: "John Smith, CEO at ABC Company",
    },
    {
      quote:
        "I've been consistently impressed with the quality of service provided by this company. Highly recommended! ER erg ersrt hhrs hqhet hqethethq hetnhqr eth nene neqt nqen etnhte qne netnq qnqet Highly recommended! ER erg ersrt hhrs hqhet hqethethq hetnhqr eth nene neqt nqen etnhte qne netnq qnqet Highly recommended! ER erg ersrt hhrs hqhet hqethethq hetnhqr eth nene neqt nqen etnhte qne netnq qnqet ",
      author: "Emily Johnson, Marketing Manager",
    },
    // Add more testimonials as needed
  ];

  function goToPrevTestimonial() {
    testimonialIndex =
      (testimonialIndex - 1 + testimonials.length) % testimonials.length;
  }

  function goToNextTestimonial() {
    testimonialIndex = (testimonialIndex + 1) % testimonials.length;
  }
  const showRight = writable(false);

  function handleScrollsf() {
    // Add logic to update showRight based on scroll position or other conditions
    showRight.set(true);
  }

  onMount(() => {
    emailjs.init("fHRZE2qnPN5GaQpnY");
    window.addEventListener("scroll", handleScrollsf);
    return () => {
      window.removeEventListener("scroll", handleScrollsf);
    };
  });

  function handleRightScroll(currentScrollPos) {
    const rightsf1 = document.querySelector(".rightsf1-content");

    // Check if all content in rightsf1 is visible
    const rect = rightsf1.getBoundingClientRect();
    if (rect.bottom <= window.innerHeight) {
      // If all content is visible, set scrollCompleted to true
      scrollCompleted = true;
    } else {
      // If not, adjust the scroll position of rightsf1-content
      const scrollDistance = 20; // Adjust this value as needed
      rightsf1.scrollTop += scrollDistance;
    }
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
</svelte:head>

<div class="serv1">
  <div class="image-container">
    <img src="/img/13.jpg" alt="Background Image" />
    <div class="overlay"></div>
    <!-- Overlay layer -->
  </div>
  <div class="content1">
    <h1 class="services-heading">Blockchain</h1>
    <p class="services-description">
      Why settle for one developer when you can leverage a full team of experts to build robust,
      high-performance blockchain solutions?
    </p>
  </div>
</div>
<div class="se2">
  <div class="lefts2">
    <h2>
      Benefits of Blockchain Development Services
    </h2>
    <p>
      Partnering with Craft2Code gives you access to a full team of blockchain and digital
      development experts, ready to:
    </p>
    <ul>
      <li>Deliver secure, scalable, and high-performance blockchain solutions tailored to your business needs.</li>
      <li>
        Accelerate project timelines while maintaining reliability and quality.
      </li>
      <li>
        Provide expert guidance for strategy, architecture, and implementation.
      </li>
      <li>
        Ensure compliance and security, protecting your data and digital assets.
      </li>
    </ul>
    <div class="left12">
      <h3><i class="fas fa-check-circle"></i> development Service for You</h3>
      <p>
        We know that every businesses’ needs are <br />completely different from
        the next, so we<br /> offer packages for any business size or<br /> budget.
      </p>
      <h3><i class="fas fa-check-circle"></i> Predictable Costs 24/7</h3>
      <p>
        We doesn’t charge you more when your<br /> network is down or a server
        fails. Our flat-<br />rate fee programs covers all of that
        <br />whenever you need it done.
      </p>
    </div>
    <div class="right12">
      <h3><i class="fas fa-check-circle"></i>Keeping Your Team Productive</h3>
      <p>
        Our managed services include round-the-clock <br />monitoring of your
        key infrastructure,<br /> computers and network servers.
      </p>
      <h3><i class="fas fa-check-circle"></i>Our Team is Ready to Help</h3>
      <p>
        Part of what makes our managed services so<br /> exceptional is that we
        are always available, <br />regardless of time or holiday.
      </p>
    </div>
  </div>
  <div class="rights2">
    <img src="/img/14.jpg" alt="Your Image Description" />
  </div>
</div>

<div class="se3">
  <div class="lefts3">
    <img src="/img/15.jpg" alt="IT Services" />
  </div>
  <div class="rights3">
    <h2>
      Focus on What Matters Most
    </h2>
    <p>
      Our blockchain and development services allow you to focus on growing
      your business while we handle the technical complexity.
    </p>
    <p>
      If your digital infrastructure is consuming time and resources instead
      of driving results, Craft2Code provides the expertise and structured
      development approach needed to deliver efficient, secure, and scalable
      solutions.
    </p>
    <p>
      With a dedicated team supporting your project, you gain the strategic
      advantage of reliable execution and technical excellence.
    </p>
  </div>
</div>
<div class="sof1" on:scroll={handleScrollsf}>
  <div class="leftsf1">
    <div class="leftsf1-content">
      <h2>Cutting-edge tools<br />that drive performance</h2>
      <p>
        If your technology is draining resources rather than optimizing them, we
        can get you<br />
        back on track. A professionally managed services provider can give you the
        decisive<br />
        edge to:
      </p>
      <img src="/img/sof1.png" alt="IT Services" />
    </div>
  </div>

  {#if $showRight}
    <div class="rightsf1">
      <div class="arrow-icons top">
        <i class="fas fa-arrow-down"></i>
        <i class="fas fa-arrow-down"></i>
      </div>
      <div class="rightsf1-content">
        <div class="rightsf1-item">
          <h3>Technical Implementation</h3>
          <p>
            From architecture design to deployment, we ensure seamless
            implementation of blockchain and software solutions tailored to your business objectives.
          </p>
        </div>
        <div class="separator"></div>
        <div class="rightsf1-item">
          <h3>Development Support</h3>
          <p>
            Our responsive support team assists with troubleshooting, updates,
            and performance optimization to keep your systems running smoothly.
          </p>
        </div>
        <div class="separator"></div>
        <div class="rightsf1-item">
          <h3>Managed Development Services</h3>
          <p>
            We provide ongoing development and maintenance
            services to ensure your applications remain secure, efficient, and aligned with your growth strategy.
          </p>
        </div>
        <div class="separator"></div>
        <div class="rightsf1-item">
          <h3>Blockchain & Technology Consulting</h3>
          <p>
            Our experts offer strategic guidance to help you
            define the right architecture, tools, and roadmap for successful blockchain integration.
          </p>
        </div>
        <div class="separator"></div>
        <div class="rightsf1-item">
          <h3>Infrastructure & Integration Support</h3>
          <p>
            We ensure smooth integration between blockchain
            solutions and your existing systems for stable and scalable performance.
          </p>
        </div>
        <div class="separator"></div>
        <div class="rightsf1-item">
          <h3>On-Demand Technical Assistance</h3>
          <p>
            Whether during critical launches or scaling phases, our
            team is available to provide timely, expert support whenever needed.
          </p>
        </div>
      </div>
      <div class="arrow-icons bottom">
        <i class="fas fa-arrow-up"></i>
        <i class="fas fa-arrow-up"></i>
      </div>
    </div>
  {/if}
</div>

<div class="cont">
  <div class="leftco">
    <!-- <div class="top-left-text1">Contact Us</div> -->
    <div class="bottom-left-textc">
      Partner with us <br /> for development
    </div>
    <div class="left-text">
      We’re happy to answer any questions you may have and help<br /> you determine
      which of our services best fit your needs.
    </div>
    <div class="left-text">Call us at: 76 361 951</div>
    <div class="left-text">Your benefits:</div>
    <div class="benefits-container">
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Client-oriented
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Independent
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Competent
        </div>
      </div>
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Results-driven
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Problem-solving
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Transparent
        </div>
      </div>
    </div>
    <div class="left-text">What happens next?</div>
    <div class="steps">
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We Schedule a call at<br /> your convenience
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We do a discovery <br />and consulting meting
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We prepare a<br /> proposal
      </div>
    </div>
  </div>
  <div class="rightco">
    <div class="contact-form-container">
      <h2 style="text-align: center;">Schedule a Free Consultation</h2>
      <div class="contact-form">
        <div class="form-group">
          <div class="name-inputs">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              bind:value={firstName}
              required
            />
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              bind:value={lastName}
              required
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company/Organization"
            bind:value={company}
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Company Email"
            bind:value={email}
            required
          />
        </div>
        <div class="form-group">
          <input type="text" id="phone" name="phone" placeholder="Phone" bind:value={phone} />
        </div>
        <div class="form-group">
          <select id="helpOption" name="helpOption" bind:value={helpOption}>
            <option value="">How can we help you?</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Software Development">Software Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Blockchain">Blockchain</option>
            <option value="Game Development">Game Development</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <textarea id="message" name="message" rows="6" placeholder="Message" bind:value={message}
          ></textarea>
        </div>
        {#if submitStatus === "success"}
          <p class="form-success">✅ Message sent successfully! We'll be in touch soon.</p>
        {:else if submitStatus === "error"}
          <p class="form-error">❌ Something went wrong. Please try again or email us at craft2code743@gmail.com</p>
        {/if}
        <button type="button" class="submit-button" disabled={submitting} on:click={handleSubmit}>
          {submitting ? "Sending..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="footer-content">
    <div class="leftfoo">
      <div class="footer-section">
        <div class="links-development">
          <div class="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home" style="color: black;">Home</Link></li>
              <li><Link to="/service" style="color: black;">Services</Link></li>
              <li><Link to="/about" style="color: black;">About Us</Link></li>
              <li>
                <Link to="/contact" style="color: black;">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div class="development">
            <h4>Development</h4>
            <ul>
              <li>
                <Link to="/mobileapp" style="color: black;">Mobile App</Link>
              </li>
              <li>
                <Link to="/software" style="color: black;">Web</Link>
              </li>
              <li><Link to="/game" style="color: black;">Game</Link></li>
              <li><Link to="/web" style="color: black;">Software</Link></li>
              <li>
                <Link to="/blockchain" style="color: black;">Blockchain</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

     
    </div>
    <div class="rightfo">
      <div class="image-containerff">
        <img src="/img/34.png" alt="Footer Image" id="footerImage" />
        <div class="text-overlay">
          <h2 style="transform: scale(0.7);"><img src="/img/logo12.png" /></h2>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="hofo">
  <div class="detail-containerfo">
    <div class="detailfo">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
      </p>
      <p>
        <span style="color: black; font-size: 24px;">CLUTCH</span>
        <span style="color: gray;">31 reviews</span>
      </p>
    </div>
    <!-- <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>God Of Mining</p>
      <p>Lebanon</p>
    </div> -->
    <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>T: 76 361 951</p>
      <p>E: Info@craft2code.com</p>
    </div>
    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.linkedin.com/company/craft2code" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </p>
      <p>LinkedIn</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.instagram.com/craft2code/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </p>
      <p>Instagram</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.facebook.com/craft2code" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </p>
      <p>Facebook</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://maps.app.goo.gl/wCDPsTqkkNU39Fds6" target="_blank">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </p>
      <p>Location</p>
    </div>
  </div>
  <div class="center-textfooo">
    <p>© 2024Tecnologia Terms & Conditions Privacy Policy</p>
  </div>
</div>

<style>
  /* css for footer */

  .hofo {
    padding: 20px;
  }

  .detail-containerfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detailfo {
    flex: 1;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .vertical-linefo {
    border-left: 1px solid #ccc;
    margin: 0 10px;
  }

  .detailfo p {
    margin: 0;
    font-size: 0.8rem;
  }

  .detailfo .blue-textfo i {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stars {
    font-size: 24px;
  }

  .blue-textfo p:first-child {
    margin: 0;
    font-size: 0.8rem;
    color: #dc1f26;
  }

  .blue-textfo p:first-child i {
    margin: 0;
    font-size: 1.2rem;
    color: #dc1f26;
  }

  .blue-textfo p:last-child {
    color: black;
  }

  .hofo {
    border-top: 1px solid #ccc;
    padding: 10px 0;
    margin-top: 20px;
  }

  .center-textfooo {
    text-align: center;
    margin-top: 20px;
  }

  .rightfo .image-containerff {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .rightfo img {
    width: 100%;
    height: 100%; /* Make the image take full height */
    object-fit: cover; /* Ensure the image covers the container */
    transition: transform 0.5s; /* Add transition effect for scaling */
  }

  .rightfo img:hover {
    transform: scale(1.1); /* Increase scale on hover */
  }
  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
  }


  .footer {
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    height: auto; /* Set the footer height to full viewport height */
  }
  .footer-content {
    display: flex;
  }

  .leftfoo {
    height: 100%;
    width: 50%;
  }

  .rightfo {
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    text-align: center;
    height: 100%; /* Ensure it takes full height */
  }

  .leftfoo .footer-section {
    margin-bottom: 20px;
  }

  .rightfo button {
    background-color: #39e9e0;
    color: #333333;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .rightfo h2 {
    color: #333333;
    font-family: BreeSerif;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .leftfoo .footer-section h4 {
    color: #333333;
    font-size: 1.8rem;
    font-family: SourceSans;
    font-weight: bold;
    margin-top: 65px;
  }

  .leftfoo .footer-section ul {
    list-style: none;
    padding-top: 0px;
    margin-top: 0;
  }

  .leftfoo .footer-section ul li {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .leftfoo .footer-section ul li a {
    color: #333333;
    font-family: SourceSans;
    text-decoration: none;
  }

  .leftfoo .footer-section ul li a:hover {
    color: #dc1f26;
  }

  .leftfoo .footer-section input[type="email"] {
    margin-top: 50px;
    padding: 15px;
    border: none;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 20px;
    background-color: #333333;
    color: white;
    border: 2px solid white; /* Set transparent border by default */
    width: calc(100% - 200px); /* Adjusted width to account for margin */
  }

  .leftfoo .footer-section input[type="checkbox"] {
    margin-top: 15px;
    margin-left: 30px;
    margin-right: 10px;
    transform: scale(1);
  }

  .leftfoo .footer-section .checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    margin-top: 15px;
  }
  .leftfoo .footer-section label {
    padding-right: 200px;
    font-size: 0.8rem; /* Increase font size of the checkbox label */
  }
  .leftfoo .footer-section button {
    background-color: #333333;
    margin-left: 30px;
    margin-top: 40px;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .leftfoo .footer-section button:hover {
    background-color: #dc1f26;
  }
  .rightfo h2 {
    z-index: 10;
  }

  .rightfo button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .rightfo button::before,
  .rightfo button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .rightfo button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .rightfo button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .rightfo button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .rightfo button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .rightfo button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .links-development {
    display: flex;
  }

  .quick-links,
  .development {
    margin-left: 30px;
    padding-top: 5px;
    flex: 1;
  }

  .quick-links ul,
  .development ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .quick-links h4,
  .development h4 {
    font-size: 1.9rem;
  }

  /* css for contact */
  .cont {
    padding-top: 70px;
    display: flex;
    /* background: linear-gradient(
      to bottom,
      white 0%,
      white 19%,
      #dc1f26 20%,
      red 70%,
      white 71%
    ); */
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #ffffff); */
    width: 100%;
  }

  .leftco {
    flex: 70%; /* Set the left div to take up 70% of the available space */
    color: #333333;
    padding-left: 120px;
  }

  .left-text {
    padding-top: 50px;
    font-size: 1.3em;
    font-family: BreeSerif;
  }

  .benefits-container {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }

  .benefits {
    flex: 1;
    font-family: BreeSerif;
  }

  .benefit {
    padding: 5px 0;
    font-family: SourceSans;
  }

  .benefit i {
    margin-right: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    font-family: BreeSerif;
  }

  .step {
    padding-bottom: 20px;
    flex: 1;
    font-family: SourceSans;
  }

  .top-left-text1 {
    /* top: 20px; */
    padding-top: 0px;
    margin-top: 0px;
    font-family: SourceSans;

    font-size: 18px;
  }
  .name-inputs {
    display: flex;
  }

  .name-inputs input {
    flex: 1; /* Take up equal space */
    margin-right: 10px; /* Add space between inputs */
  }

  .name-inputs input:last-child {
    margin-right: 0; /* Remove margin from last input */
  }
  .rightco {
    background-color: white;
    /* margin-top: 10px; */
    margin-right: 200px;
    margin-bottom: 30px;
    flex: 50%; /* Set the right div to take up 30% of the available space */
  }

  .contact-form-container {
    display: flex;
    flex-direction: column; /* Align items vertically */
    align-items: center; /* Center items horizontally */
    padding-right: 20px;
  }

  .contact-form-container h2 {
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .form-group select {
    appearance: none;
    -webkit-appearance: none;
  }

  .form-group textarea {
    resize: vertical;
  }

  .submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-success {
    color: #1a7a3a;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .form-error {
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .submit-button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .submit-button::before,
  .submit-button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .submit-button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .submit-button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .submit-button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .submit-button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .submit-button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .bottom-left-textc {
    font-size: 60px;
    margin-top: 0px;
    font-weight: bold;
    font-family: SourceSans;
  }
  .testimonials-section {
    position: relative;
    text-align: center;

    width: 60%;
    margin-left: auto; /* Auto margin from left */
    margin-right: auto; /* Auto margin from right */
  }

  .testimonial {
    padding: 30px 0; /* Increase padding */
  }

  .quote {
    font-style: italic;
    font-size: 1.7rem; /* Increase font size */
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    font-weight: bold;
    font-family: BreeSerif;
  }
  .clients-text {
    color: #333333;
    font-family: BreeSerif;
    font-size: 60px; /* Adjust font size */
    margin-bottom: 20px;
  }

  .author {
    font-size: 1.2rem; /* Increase font size */
    font-family: SourceSans;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 30px;
    text-align: left;
  }

  .arrow-buttons-container {
    margin-left: 20px; /* Add margin between buttons and text */
  }

  .additional-info1 {
    display: flex;
    justify-content: space-between; /* Align items to the edges */
    align-items: center; /* Center vertically */
    margin-top: 1px; /* Adjust as needed */
  }

  .detail1 {
    font-size: 1.2rem;
    text-align: right; /* Align text to the right */
  }
  .arrow-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #054f76;
    font-size: 24px;
    margin: 0 10px; /* Add some space between buttons */
  }

  .arrow-button.left11 {
    margin-right: 20px;
  }

  .arrow-button.right11 {
    margin-left: 20px;
  }

  .additional-info2 {
    display: flex;
    align-items: center;
  }
  /* --------------------------------------------------------- */

  .sof1 {
    display: flex;
    margin-top: 100px;
    height: 100vh; /* Full viewport height */
    position: relative;
    overflow: hidden; /* Prevent scrolling of the parent container */
  }
  .leftsf1 {
    display: flex;
    height: 100%; /* Ensure leftsf1 takes full height */
  }
  .leftsf1,
  .rightsf1 {
    width: 50%;
    overflow: hidden; /* Prevent individual scrolling */
  }
  .rightsf1 {
    position: relative;
  }
  .rightsf1-content {
    width: 100%;
    display: flex;
    margin-top: 30px;
    flex-direction: column;
    justify-content: space-between;
    height: 80%; /* Adjust height to fit container */
    overflow-y: auto; /* Add vertical scroll if content overflows */
  }
  .leftsf1-content {
    padding: 20px;
    position: relative;
  }
  .leftsf1-content h2 {
    font-size: 48px;
  }
  .leftsf1-content h2,
  .leftsf1-content p {
    position: relative;
    z-index: 1;
    text-align: center;
  }
  .leftsf1-content img {
    justify-content: center;
    width: 70%;
    text-align: right;
    transform: scale(1); /* Scale the image by a factor of 2 */
  }
  .rightsf1-item {
    display: flex;
    flex-direction: column; /* Ensure h3 and p are in column */
    align-items: flex-start; /* Align items to the start */
    padding: 20px 0;
    border-bottom: 1px solid black;
  }
  .rightsf1-item h3 {
    margin-left: 20px;
    margin-bottom: 10px; /* Ensure consistent spacing between h3 and p */
  }
  .rightsf1-item p {
    margin-left: 20px;
  }
  .rightsf1-content::-webkit-scrollbar {
    display: none;
  }
  .icon {
    width: 20px;
    height: 20px;
    background-color: blue;
    border-radius: 100%;
    position: relative;
  }
  .separator {
    width: 100%;
    height: 3px;
    background-color: #ccc;
    margin: 20px 0; /* Add margin to ensure separation between items */
  }
  .arrow-icons {
    display: flex;
    justify-content: center;
    position: absolute;
    width: 100%;
  }
  .arrow-icons.top {
    top: 0;
  }
  .arrow-icons.bottom {
    bottom: 0;
  }
  .arrow-icons i {
    font-size: 2em;
    color: #555555;
    margin: 10px;
  }
  /* -------------------------------------------------- */
  .se2 {
    display: flex;

    margin-bottom: 50px;
  }

  .lefts2 {
    width: 60%;
    background: white;
    height: 100%;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
  }

  .rights2 {
    width: 40%;
    background: white;
    padding: 20px;
    height: 680px;
  }

  .lefts2 h2 {
    font-size: 40px;
    margin-bottom: 20px;
  }

  .lefts2 p {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .lefts2 ul {
    list-style-type: disc;
    padding-left: 20px;
  }

  .lefts2 ul li {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .left12,
  .right12 {
    width: 50%;
    box-sizing: border-box;
    padding-right: 20px;
  }

  .right12 {
    padding-right: 0;
  }

  .left12 h3 i,
  .right12 h3 i {
    background-color: rgb(255, 255, 255);
    color: #054f76;
    border-radius: 50%;
    margin-right: 10px;
  }

  .left12 p,
  .right12 p {
    font-size: 16px;
    margin-bottom: 20px;
    position: relative;
  }

  .rights2 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-top: 20px;
  }

  /* Base Styles for se3 */
  /* .se3 {
    margin-top: 100px;
    display: flex;
    height: 400px; 
  }

  .lefts3 {
    margin-left: 40px;
    width: 60%;
  }

  .lefts3 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .rights3 {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
  }

  .rights3 h2 {
    font-size: 35px;
    margin-bottom: 20px;
    font-family: "Bree Serif", serif;
  }

  .rights3 p {
    font-size: 16px;
    line-height: 1.5;
  } */
  /* .se2 {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 50px; 
  }

  .lefts2 {
    width: 60%;
    background: white;
    padding: 20px;
    display: flex;
    flex-wrap: wrap; 
    box-sizing: border-box; 
  }

  .rights2 {
    width: 40%;
    background: white;
    padding: 20px;
    box-sizing: border-box; 
  }

  .lefts2 h2 {
    font-size: 2.5rem;
    margin-bottom: 20px;
  }

  .lefts2 p {
    font-size: 1rem;
    margin-bottom: 20px;
  }

  .lefts2 ul {
    list-style-type: disc;
    padding-left: 20px; 
  }

  .lefts2 ul li {
    font-size: 1rem;
    margin-bottom: 10px;
  }

  .left12,
  .right12 {
    width: 100%;
    box-sizing: border-box; 
    padding-right: 20px; 
  }

  .right12 {
    padding-right: 0; 
  }

  .left12 h3 i,
  .right12 h3 i {
    background-color: rgb(255, 255, 255);
    color: #054f76;
    border-radius: 50%;
    margin-right: 10px;
  }

  .left12 p,
  .right12 p {
    font-size: 1rem;
    margin-bottom: 20px;
    position: relative;
  }

  .rights2 img {
    width: 100%;
    height: auto;
    object-fit: cover;
    margin-top: 20px;
  } */

  /* Base Styles for se3 */
  .se3 {
    display: flex;
    flex-wrap: wrap;
  }

  .lefts3 {
    width: 60%;
    padding: 20px;
    box-sizing: border-box; /* Include padding in width calculation */
  }

  .lefts3 img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .rights3 {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box; /* Include padding in width calculation */
  }

  .rights3 h2 {
    font-size: 2.2rem;
    margin-bottom: 20px;
    font-family: "Bree Serif", serif;
  }

  .rights3 p {
    font-size: 1rem;
    line-height: 1.5;
  }

  .serv1 {
    text-align: center;
    margin-bottom: 40px;
    width: 100%; /* Full width */
    position: relative;
    height: 100vh;
  }

  .image-container {
    width: 100%;
    height: 100%; /* Full height */
    overflow: hidden; /* Ensures image doesn't exceed container */
    position: relative; /* Needed for overlay positioning */
  }

  .image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent overlay */
    z-index: 1; /* Position overlay above image but below content */
  }

  .content1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40%;
    text-align: center;
    color: white;
    z-index: 2; /* Ensure content is above the overlay */
    padding: 0 20px; /* Padding for better readability */
  }

  .services-heading {
    font-size: 65px;
    font-family: BreeSerif;
  }

  .services-description {
    color: white; /* Changed to white for better contrast */
    font-size: 1.4rem;
    font-family: SourceSans;
    margin-top: 20px;
  }

  @media (min-width: 1040px) and (max-width: 1324px) {
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }
    .serv1 {
      height: 100vh; /* Full viewport height */
    }

    .image-container {
      height: 100%; /* Full height */
    }

    .content1 {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 45%; /* Adjust width */
      font-size: 1.5rem; /* Adjust font size */
    }

    .services-heading {
      font-size: 4rem; /* Adjust font size */
    }

    .services-description {
      font-size: 1.4rem; /* Adjust font size */
    }
    .sof1 {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
      display: flex;
      flex-direction: row; /* Display left and right side by side */
      align-items: center; /* Center items vertically */
    }

    /* Adjustments for the left side */
    .leftsf1 {
      width: 50%;
      margin-right: auto; /* Align to the right */
    }

    /* Adjustments for the right side */
    .rightsf1 {
      width: 50%;
      margin-left: auto; /* Align to the left */
    }

    .arrow-icons {
      display: none; /* Hide arrow icons */
    }

    .leftsf1-content img {
      display: none; /* Hide image */
    }
    .se2 {
      flex-direction: column;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .se3 {
      flex-direction: column;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .lefts2,
    .lefts3 {
      width: 100%;
      padding: 0px;
    }

    .rights2,
    .rights3 {
      width: 100%;
      padding: 0px;
    }

    .lefts2 h2,
    .rights3 h2 {
      font-size: 2.5rem;
    }

    .lefts2 ul {
      columns: 2; /* Create two columns for the list items */
    }

    .left12,
    .right12 {
      width: 50%; /* Adjust width for side-by-side display */
      padding-right: 10px;
    }

    .right12 {
      padding-left: 10px; /* Add padding to separate columns */
    }

    .rights2 img {
      height: 100%;
    }
    .lefts3 img {
      width: 100%;
      height: 100%; /* Set the height for the image */
    }
  }
  @media (min-width: 769px) and (max-width: 1060px) {
    .se2 {
      flex-direction: column;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .se3 {
      flex-direction: column;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .lefts2,
    .lefts3 {
      width: 100%;
      padding: 0px;
    }

    .rights2 {
      width: 100%;
      padding: 0px;
    }
    .rights3 {
      margin-left: auto;
      width: 85%;
      padding: 0px;
    }

    .lefts2 h2,
    .rights3 h2 {
      font-size: 2.2rem;
    }

    .lefts2 ul {
      columns: 2; /* Create two columns for the list items */
    }

    .left12,
    .right12 {
      width: 50%; /* Adjust width for side-by-side display */
      padding-right: 10px;
    }

    .right12 {
      padding-left: 10px; /* Add padding to separate columns */
    }

    .rights2 img {
      height: 100%;
    }
    .lefts3 img {
      height: 400px; /* Set the height for the image */
    }
    .serv1 {
      height: 100vh; /* Full viewport height */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .image-container {
      height: 100%; /* Full height */
    }

    .content1 {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50%; /* Adjust width */
      font-size: 1.4rem; /* Adjust font size */
    }

    .services-heading {
      font-size: 3.5rem; /* Adjust font size */
    }

    .services-description {
      font-size: 1.3rem; /* Adjust font size */
    }
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }
    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.3rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.75rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
    .sof1 {
      flex-direction: column;
      height: auto; /* Adjust height to fit content */
      margin-top: 50px; /* Adjust margin-top */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .rightsf1 {
      width: 100%;
      height: auto; /* Adjust height to fit content */
      overflow: visible; /* Allow overflow for content */
    }

    .leftsf1 {
      width: 85%;
      height: auto; /* Adjust height to fit content */
      overflow: visible; /* Allow overflow for content */
      text-align: left;
      margin-left: auto;
    }

    .leftsf1-content h2 {
      font-size: 32px; /* Adjust font-size */
      text-align: left;
    }

    .leftsf1-content p {
      font-size: 14px; /* Adjust font-size */
      text-align: left; /* Align text to the left */
    }

    .leftsf1-content img {
      display: none; /* Hide image */
    }

    .rightsf1-content {
      height: auto; /* Adjust height to fit content */
      margin-top: 0; /* Adjust margin-top */
      padding: 20px; /* Add padding */
      overflow-y: visible; /* Allow overflow for content */
    }

    .rightsf1-item h3 {
      font-size: 20px; /* Adjust font-size */
    }

    .rightsf1-item p {
      font-size: 14px; /* Adjust font-size */
    }

    .arrow-icons {
      display: none; /* Hide arrow icons */
    }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    .serv1 {
      height: 100vh; /* Full viewport height */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .image-container {
      height: 100%; /* Full height */
    }

    .content1 {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60%; /* Adjust width */
      font-size: 1.2rem; /* Adjust font size */
    }

    .services-heading {
      font-size: 3rem; /* Adjust font size */
    }

    .services-description {
      font-size: 1.2rem; /* Adjust font size */
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
    .text-overlay1 h2,
    .text-overlay1 button {
      margin-bottom: 0px;
    }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay1 button {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
    }
    .text-overlay1 h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }

    .vertical-linefo {
      display: none; /* Hide vertical line */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
    .se2,
    .se3 {
      flex-direction: column;
      margin-bottom: 0px;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }
    .lefts3 {
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
    }
    .lefts2 {
      width: 100%;
      padding: 0px;
    }
    .rights3 {
      margin-left: auto;
      width: 85%;
      padding: 0px;
    }
    .rights2 {
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
    }

    .lefts2 h2,
    .rights3 h2 {
      font-size: 35px;
    }
    .lefts2 ul {
      columns: 2; /* Create two columns for the list items */
    }
    .left12,
    .right12 {
      width: 50%;
      padding-right: 0;
    }

    .rights2 img {
      width: 100%;
    }
    .lefts3 img {
      height: 400px; /* Adjust height for medium screens */
    }
    .sof1 {
      flex-direction: column;
      height: auto; /* Adjust height to fit content */
      margin-top: 50px; /* Adjust margin-top */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .rightsf1 {
      width: 100%;
      height: auto; /* Adjust height to fit content */
      overflow: visible; /* Allow overflow for content */
    }
    .leftsf1 {
      width: 85%;
      margin-left: auto;
      height: auto; /* Adjust height to fit content */
      overflow: visible; /* Allow overflow for content */
    }
    .leftsf1-content h2 {
      text-align: left;
      font-size: 32px; /* Adjust font-size */
    }

    .leftsf1-content p {
      text-align: left;
      font-size: 14px; /* Adjust font-size */
    }

    .leftsf1-content img {
      display: none; /* Hide image */
    }

    .rightsf1-content {
      height: auto; /* Adjust height to fit content */
      margin-top: 0; /* Adjust margin-top */
      padding: 20px; /* Add padding */
      overflow-y: visible; /* Allow overflow for content */
    }

    .rightsf1-item h3 {
      font-size: 20px; /* Adjust font-size */
    }

    .rightsf1-item p {
      font-size: 14px; /* Adjust font-size */
    }

    .arrow-icons {
      display: none; /* Hide arrow icons */
    }
  }

  /* For screens with a maximum width of 550px */
  @media (max-width: 480px) {
    .sof1 {
      flex-direction: column;
      height: auto; /* Adjust height to fit content */
      margin-top: 0px; /* Adjust margin-top */
    }

    .leftsf1,
    .rightsf1 {
      width: 100%;
      height: auto; /* Adjust height to fit content */
      overflow: visible; /* Allow overflow for content */
    }

    .leftsf1-content h2 {
      font-size: 24px; /* Adjust font-size */
    }
    .leftsf1-content {
      padding-bottom: 0px;
      margin-bottom: 0px;
    }

    .leftsf1-content p {
      font-size: 14px; /* Adjust font-size */
      text-align: center; /* Align text to the left */
    }

    .leftsf1-content img {
      display: none; /* Hide image */
    }

    .rightsf1-content {
      height: auto; /* Adjust height to fit content */
      margin-top: 0; /* Adjust margin-top */
      padding: 20px; /* Add padding */
      overflow-y: visible; /* Allow overflow for content */
    }

    .rightsf1-item h3 {
      font-size: 20px; /* Adjust font-size */
    }

    .rightsf1-item p {
      font-size: 14px; /* Adjust font-size */
    }

    .arrow-icons {
      display: none; /* Hide arrow icons */
    }
    .se3 {
      margin-top: 0px;
      flex-direction: column;
      align-items: center;
      height: auto; /* Adjust height as needed */
    }

    .lefts3 {
      width: 100%;
      margin-left: 0;
      padding-left: 0px;
      padding-right: 0px;
    }

    .rights3 {
      width: 100%;
      padding: 5px;
      text-align: center;
    }

    .rights3 h2 {
      font-size: 20px;
    }

    .rights3 p {
      font-size: 13px;
    }
    .se2 {
      flex-direction: column;
      margin-bottom: 0px;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }

    .lefts2,
    .rights2 {
      width: 100%;
      padding: 0px;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }

    .lefts2 h2 {
      font-size: 30px;
    }

    .left12,
    .right12 {
      width: 100%;
      padding-right: 0;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .rights2 {
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      margin-bottom: 5%;
    }
    .rights2 img {
      margin-bottom: 4%;
      height: 100%; /* Adjust height for smaller screens */
    }
    .serv1 {
      height: 100vh; /* Full viewport height */
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
    }

    .image-container {
      height: 100%; /* Full height */
    }

    .image-container img {
      width: 100%; /* Ensure the image is full width */
      height: 100%; /* Maintain height */
    }

    .overlay {
      display: block; /* Ensure the overlay is visible */
    }

    .content1 {
      position: absolute; /* Keep content absolute */
      top: 50%; /* Center vertically */
      left: 50%; /* Center horizontally */
      transform: translate(-50%, -50%); /* Center transformation */
      width: 80%; /* Adjust width for smaller screens */
      color: white; /* Keep text color white */
      padding: 0 0px; /* Adjust padding */
    }

    .services-heading {
      font-size: 2rem; /* Adjust font size */
      color: white; /* Keep text color white */
    }

    .services-description {
      font-size: 1rem; /* Adjust font size */
      color: white; /* Keep text color white */
    }

    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
    .text-overlay1 h2,
    .text-overlay1 button {
      margin-bottom: 0px;
    }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30px;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
    }

    .detail-containerfo {
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%;
      box-sizing: border-box;
    }

    .detailfo:nth-child(3) {
      width: 100%; /* Full width for the address section */
      padding: 10px 0; /* Add some padding for the address section */
    }

    .vertical-linefo {
      display: none;
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay1 button {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
    }
    .text-overlay1 h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }
    .benefits-container,
    .steps {
      flex-direction: column;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }

    .vertical-linefo {
      display: none; /* Hide vertical line */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
  }
</style>
